import { Tag } from 'antd';
import { LockOutlined, CheckCircleTwoTone, StopOutlined } from '@ant-design/icons';
import { CATEGORY_TYPE_OPTIONS, CATEGORY_TYPE_COLOR } from './itemConfigConstants';

const TYPE_LABEL = Object.fromEntries(
  CATEGORY_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export function buildCategoryColumns({ currentPage, pageSize } = {}) {
  return [
    {
      title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return <span className="erp-grid__muted">{(cp - 1) * ps + idx + 1}</span>;
      }
    },
    {
      title: 'Code', key: 'categoryCode', dataIndex: 'categoryCode',
      sortField: 'category_code', sorter: true,
      width: 180, fixed: 'left', dataType: 'string',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Name', key: 'categoryName', dataIndex: 'categoryName',
      sortField: 'category_name', sorter: true,
      width: 240, ellipsis: true, dataType: 'string',
      render: (v) => <span className="erp-grid__primary">{v}</span>
    },
    {
      title: 'Parent', key: 'parentCategoryCode', dataIndex: 'parentCategoryCode',
      sortField: 'parent_code',
      width: 180, dataType: 'string',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Type', key: 'categoryType', dataIndex: 'categoryType',
      sortField: 'category_type', sorter: true,
      filterField: 'category_type',
      width: 120, dataType: 'enum',
      filters: CATEGORY_TYPE_OPTIONS.map((o) => ({ text: o.label, value: o.value })),
      render: (v) => v
        ? <Tag color={CATEGORY_TYPE_COLOR[v] || 'default'} className="erp-grid__tag">
            {TYPE_LABEL[v] || v}
          </Tag>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'System', key: 'isSystem', dataIndex: 'isSystem',
      sortField: 'is_system', sorter: true,
      filterField: 'is_system',
      width: 100, align: 'center', dataType: 'boolean',
      filters: [{ text: 'System', value: 'true' }, { text: 'User', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<LockOutlined />} color="default" className="erp-grid__tag">System</Tag>
        : <span className="erp-grid__muted">User</span>
    },
    {
      title: 'Status', key: 'isActive', dataIndex: 'isActive',
      sortField: 'is_active', sorter: true,
      filterField: 'is_active',
      width: 110, align: 'center', dataType: 'boolean',
      filters: [{ text: 'Active', value: 'true' }, { text: 'Inactive', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<CheckCircleTwoTone twoToneColor="#52c41a" />} color="success" className="erp-grid__tag">Active</Tag>
        : <Tag icon={<StopOutlined />} color="default" className="erp-grid__tag">Inactive</Tag>
    }
  ];
}
